import React, { useContext, useState } from 'react';
import { colors } from '@guryou/colors';
import { WidgetContext } from './WidgetContext';
import WidgetMembershipDetail from './WidgetMembershipDetail';

const WidgetMemberships = () => {
  const { activeServiceId, setActiveServiceId, activeTab, memberships, fontF, fontS } = useContext(WidgetContext);
  const [openedMembershipId, setOpenedMembershipId] = useState(false);

  if (!memberships?.length) {
    return null;
  }

  const selectedService = memberships.find(m => m.id === activeServiceId);

  return (
    <div class="md:flex w-full">
      <ul class="flex-column space-y space-y-4 text-sm font-medium text-gray-500 dark:text-gray-400 md:me-4 mb-4 md:mb-0 min-w-[20%]">
        {memberships.map(service => (
          <li
            key={service.id}
            onClick={() => {
              setActiveServiceId(service.id);
            }}
          >
            <a
              key={service.id}
              href="#"
              class="inline-flex items-center px-4 py-3 text-white bg-blue-700 rounded-lg active w-full dark:bg-blue-600 relative"
              aria-current="page"
              style={{ backgroundColor: activeServiceId === service.id ? colors.mandy : colors.stormGray }}
            >
              {`${service.name} (${service?.offers.length})`}
            </a>
          </li>
        ))}
      </ul>
      <div class="p-6 pt-0 text-medium text-gray-500 dark:text-gray-400 rounded-lg w-full">
        <h3 class="text-lg font-bold text-gray-900 mb-2">{selectedService ? selectedService.name : ''}</h3>
        <p class="mb-2">Compare our available services and plans below to determine which one best suits your needs.</p>

        <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 w-full mt-8">
          {selectedService?.offers?.map(offer => {
            return (
              <WidgetMembershipDetail
                key={offer.id}
                membership={offer}
                openedMembershipId={openedMembershipId}
                setOpenedMembershipId={setOpenedMembershipId}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default WidgetMemberships;
